import React from "react";

const WhatsAppButton = () => {
  const phoneNumber = "9810201747";

  return (
    <a
      href={`https://wa.me/${phoneNumber}`}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src="https://img.icons8.com/color/96/000000/whatsapp--v1.png"
        alt="WhatsApp Chat"
        className="whatsapp-icon"
      />
    </a>
  );
};

export default WhatsAppButton;
